import styles from './SearchBar.module.css';

interface SearchBarProps {
  searchQuery: string;
  onChange: (query: string) => void;
}

export const SearchBar = ({ searchQuery, onChange }: SearchBarProps) => (
  <div className={styles.searchContainer}>
    <i className="pi pi-search" />
    <input
      type="text"
      value={searchQuery}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Search analyses by name, document, or status..."
      className={styles.searchInput}
      aria-label="Search analyses"
    />
    {searchQuery && (
      <button
        type="button"
        onClick={() => onChange('')}
        className={styles.clearButton}
        aria-label="Clear analysis search"
      >
        <i className="pi pi-times" />
      </button>
    )}
  </div>
);
